module.exports = __webpack_public_path__ + "excl.svg?f867f196b6e21b1d279c42f887c396b4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/excl.svg
// module id = 936
// module chunks = 0